import axios from "axios";
const instance = axios.create({ baseURL: "https://kapadvanjhaat.ondemandcrm.co"}); //window.location.origin//
export default instance;
